import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { mergeDeepLeft } from 'ramda';
import Select from '../../../common/controls/select';
import OptionNestedPickerModal from './optionNestedPickerModal';
import { removeFromTree, identifiersFromTree, titleForIdentifier } from './optionNestedPickerHelpers';
import { applyNullRemove, removeNulls } from '../../../../utils/contentTools';
import { leafPedigreesString } from '../../../../../behaviors/src/lib/common';
class OptionNestedPicker extends Component {
  constructor(props) {
    super(props);
    this.modalOpen = this.onModalChange.bind(this, true);
    this.modalClose = this.onModalChange.bind(this, false);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onNestedPickerChange = this.onNestedPickerChange.bind(this);
    this.state = {
      isOpen: false
    };
  }
  onModalChange(isOpen) {
    this.setState({
      isOpen
    });
  }
  onSelectChange(newValues) {
    const {
      value,
      onChange,
      path
    } = this.props;
    if (newValues.length === 0) {
      return onChange({
        path,
        value: null
      });
    }
    const currentIdentifiers = identifiersFromTree(value);
    const removedIdentifier = currentIdentifiers.find(currentIdentifier => !newValues.some(item => item.identifier === currentIdentifier));
    const updatedTree = removeFromTree(value, removedIdentifier);
    const d = JSON.parse(JSON.stringify(updatedTree));
    const displayValue = leafPedigreesString(removeNulls(d));
    return onChange({
      path,
      value: updatedTree,
      displayValue
    });
  }
  onNestedPickerChange({
    value: tree,
    changeModifiers = {}
  }) {
    const {
      onChange,
      path,
      value,
      allowsMultipleSelection
    } = this.props;
    let saveTree = tree;
    if (saveTree === null) {
      return onChange({
        path,
        value: null,
        changeModifiers
      });
    }
    if (allowsMultipleSelection) {
      saveTree = mergeDeepLeft(saveTree, value);
    }
    saveTree = applyNullRemove(saveTree);
    const d = JSON.parse(JSON.stringify(saveTree));
    const displayValue = leafPedigreesString(removeNulls(d));
    return onChange({
      path,
      value: saveTree,
      displayValue,
      changeModifiers
    });
  }
  render() {
    const {
      value,
      placeholder,
      enabled,
      allowsMultipleSelection,
      className,
      label: formatLabel,
      allowsOther,
      allowsParentSelection,
      options
    } = this.props;
    const {
      isOpen
    } = this.state;
    const identifiers = identifiersFromTree(value);
    const values = identifiers.map(identifier => {
      const label = titleForIdentifier(value, identifier);
      return {
        label,
        identifier,
        value: identifier,
        clearableValue: true,
        className: `t-onp-opt-${kebabCase(label)}`
      };
    });
    let contentValue = values;
    if (contentValue.length === 0) {
      contentValue = '';
    }
    let selectValue;
    if (!allowsMultipleSelection && contentValue) {
      selectValue = values[0];
    } else if (contentValue) {
      selectValue = contentValue.map(val => val.value);
    } else {
      selectValue = '';
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
      backspaceRemoves: false,
      onChange: this.onSelectChange,
      onOpen: this.modalOpen,
      options: values,
      labelKey: "label",
      valueKey: "value",
      id: "select",
      className: `t-onp ${className}`,
      multi: true,
      placeholder: placeholder,
      disabled: !enabled,
      values: selectValue,
      verticalPadding: false
    }), /*#__PURE__*/React.createElement(OptionNestedPickerModal, {
      allowsMultipleSelection: allowsMultipleSelection,
      allowsOther: allowsOther,
      allowsParentSelection: allowsParentSelection,
      className: className,
      closeModal: this.modalClose,
      isOpen: isOpen,
      label: formatLabel,
      onChange: this.onNestedPickerChange,
      options: options,
      value: value
    }));
  }
}
OptionNestedPicker.propTypes = {
  allowsMultipleSelection: PropTypes.bool,
  allowsOther: PropTypes.bool,
  allowsParentSelection: PropTypes.bool,
  className: PropTypes.string,
  enabled: PropTypes.bool,
  label: PropTypes.string,
  path: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
};
OptionNestedPicker.defaultProps = {
  allowsMultipleSelection: false,
  allowsOther: false,
  allowsParentSelection: true,
  className: '',
  enabled: true,
  label: '',
  options: [],
  placeholder: 'Select...',
  value: {}
};
export default OptionNestedPicker;